import { getAvatarName, getAvatarIndex } from '../data/avatarMappings';

interface AssessmentResults {
  dass: {
    depression: { severity: string };
    anxiety: { severity: string };
    stress: { severity: string };
  };
  brs: {
    severity: string;
  };
  ciss: {
    primaryStyle: 'task' | 'emotion' | 'avoidance';
  };
}

// Determine avatar based on assessment results
export const determineAvatar = (results: AssessmentResults): number => {
  // Get avatar index using the comprehensive mapping system
  return getAvatarIndex(
    results.dass.depression.severity,
    results.dass.anxiety.severity,
    results.dass.stress.severity,
    results.brs.severity,
    results.ciss.primaryStyle
  );
};